import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled, { createGlobalStyle } from "styled-components";
import PerfectScrollbar from "react-perfect-scrollbar";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

import storageService from "../services/storage.service";
import config from '../config';

import {
	Hidden,
	CssBaseline,
} from "@material-ui/core";
import GettingStartedDialog from "../components/Dialogs/GettingStartedDialog";
import SupportDialog from "../components/Dialogs/SupportDialog";
import PrivacyPolicyDialog from "../components/Dialogs/PrivacyPolicyDialog";

const drawerWidth = 280;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.body.dashboard.background};
    color: ${props => props.theme.body.dashboard.color};
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${props => props.theme.breakpoints.up("md")} {
    width: ${props => props.theme.widthRatio*drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const MainContent = styled(PerfectScrollbar)`
  flex: 1;
  background: ${props => props.theme.body.background};
  color: ${props => props.theme.body.color};
  position: relative;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const Dashboard = ({ children, routes, history, openGettingStartedDialog }) => {
	const [mobileOpen, setMobileOpen] = useState(false);
	
	useEffect(() => {
		const token = storageService.getItem(config.TOKEN_KEY);
		if (!token) {
			history.push('/auth/login');
		}
	}, [history]);

	return (
		<Root>
			<CssBaseline />
			<GlobalStyle />
			<Drawer>
				<Hidden mdUp implementation="js">
					<Sidebar
						routes={routes}
						variant="temporary"
						open={mobileOpen}
						onClose={() => setMobileOpen(!mobileOpen)}
					/>
				</Hidden>
				<Hidden smDown implementation="css">
					<Sidebar
						routes={routes}
					/>
				</Hidden>
			</Drawer>
			<AppContent>
				<Header onDrawerToggle={() => setMobileOpen(!mobileOpen)} />
				<MainContent>
					{children}
					{openGettingStartedDialog && <GettingStartedDialog />}
					<SupportDialog />
					<PrivacyPolicyDialog />
				</MainContent>
			</AppContent>
		</Root>
	);
};

const mapStateToProps = (state) => ({
	openGettingStartedDialog: state.dialogsReducer.openGettingStartedDialog,
});

export default connect(mapStateToProps)(withRouter(Dashboard));
